import React from 'react';
import ReactDOM from 'react-dom';
import GToast from './toast';

type TProps = {
  content: string,
  duration: number
}
type TToastInstance = {
  // eslint-disable-next-line no-unused-vars
  show: (props: TProps) => void
}
let toastInstance: TToastInstance | null; // toast 方法的实例

/**
 * 创建toast实例
 * @returns
 */
const createToast = () => {
  let div = null as unknown as HTMLDivElement;
  if (!div) {
    div = document.createElement('div');
    document.body.appendChild(div);
  }

  return {
    show(notice: TProps) {
      ReactDOM.render(<GToast content={notice.content} />, div); //通过ReactDOM.render 去渲染dom
      let timer = setTimeout(() => {
        if (div) {
          ReactDOM.unmountComponentAtNode(div);
          document.body.removeChild(div);
          toastInstance = null;
          clearTimeout(timer);
        }
      }, notice.duration);
    },
  };
};
/**
 * 创建谈toast的方法，供外部使用
 * @param {*} content toast内容
 * @param {*} duration toast显示的时间
 * @returns
 */
const instance = (content: string, duration = 2000) => {
  if (!toastInstance) {
    toastInstance = createToast();
    return toastInstance.show({ content, duration });
  }
};

export default instance;
